/* eslint-disable */
import React, { Component } from 'react';
import { Post, Get, Delete, Put } from '../../utility/fetch';
import { URLAPI } from '../../utility/ApiMethods';
import moment from 'moment';
import { GrEdit } from 'react-icons/gr';
import { GiRecycle } from 'react-icons/gi';
//import data from '../../data';
import { GiTrashCan } from 'react-icons/gi';
//import { GrEdit } from 'react-icons/gr';
// Icons
//import { FaEnvelopeOpenText } from 'react-icons/fa';
//import FormSearchInput from '../inputs/FormSearchInput';
import TextInput from '../inputs/TextInput';
import { deleteMessage, errorMessage, successMessage } from '../../resources/alert';
import data from '../../data';
import Cookies from 'js-cookie';
import LoadingSpinner from '../../resources/loadingSpinner';

const tableBorder = {
  border: 'none',
  borderRight: '1px solid #0000000A',
  borderBottom: '1px solid #0000000A',
};
const bottomBorder = {
  borderBottom: '.5px solid rgba(99,99,99,.6)',
};
class DisposalCAtegoryForm extends Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      category: '',
      button: 'Save Record',
      requestId: 0,
      records: [],
      catRecords: [],
      loading: false,
      bgColor: 'white',
    };
    this.handleChange = this.handleChange.bind(this);
    this.getRequestCategory = this.getRequestCategory.bind(this);
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
    });
  };

  validateForm = () => {
    const { category } = this.state;

    if (!category) return 'Please, Enter Category';
    // if (!sequence) return 'Please, Enter sequence';
    return null;
  };

  onSubmit = (e) => {
    e.preventDefault();

    let error_data = this.validateForm();

    if (error_data) {
      errorMessage(error_data);
    } else if (error_data !== this.validateForm) {
      let request = {
        id: this.state.requestId,
        category: this.state.category,
        status: 0,
      };

      if (this.state.button === 'Save Record') {
        this.onSubmitSave(request);
      } else if (this.state.button === 'Update') {
        this.onSubmitUpdate(request);
      }
    }
  };

  onSubmitSave = (data) => {
    this.setState({ loading: true }, () => {
      Post(data, URLAPI.requestCategories.Post, this.onSubmitAfterSave, Cookies.get('token'));
    });
    console.log(data);
  };

  onSubmitAfterSave = (data) => {
    if (data.code === 1) {
      successMessage(data.message);
      Get(URLAPI.requestCategories.Get, this.getRequestCategory);

      //clone the records in array
      const cat = [...this.state.records];

      //create array of data submitted
      let req = {
        id: data.id,
        category: this.state.category,
        status: 0,
        //createdBy: this.state.createdBy,
        //status: 1,
      };

      //update the new record into the array
      cat.push(req);

      //commit the new record into array
      this.setState({ records: req, loading: false, category: '' });
    } else if (data.code === 0) {
      errorMessage(data.message);
      this.setState({
        loading: false,
        category: '',
      });
    }
  };

  getRequestCategory = (data) => {
    console.log(data);

    if (this._isMounted) {
      let _records = Array.isArray(data) ? data : [];
      this.setState({ catRecords: _records, loading: false });
    }
  };

  //handle delete record
  handleDeleteRecord(record) {
    deleteMessage(() => this.onDelete(record));
  }

  onDelete = (record) => {
    console.log('clicked');
    if (record !== '') {
      this.setState({ loading: true }, () => {
        Delete(URLAPI.requestCategories.Delete + '/' + record.id, this.onAfterDelete);
      });
    }
  };

  onAfterDelete = (res) => {
    if (res.code === 1) {
      // console.log(res);
      this.setState({ loading: false });
      successMessage(res.message);
      Get(URLAPI.requestCategories.Get, this.getRequestCategory);

      this.setState({ catRecords: this.state.catRecords.filter((rec) => rec.id !== res.id) });
      // this.handleCancel();
    } else if (res.code === 0) {
      errorMessage(res.message);
      this.setState({ loading: false, visible: false });
    } else {
      errorMessage(res.message);
    }
  };

  onEdit = (item) => {
    //set record to state
    console.log('onedit', item);
    if (item) {
      this.setState({
        button: 'Update',
        requestId: item.id,
        category: item.category,
        bgColor: '#c2f542',
      });
    }
  };
  onSubmitUpdate = (record) => {
    console.log(record);
    if (this.state.requestId) {
      this.setState({ loading: true }, () => {
        Put(
          record,
          URLAPI.requestCategories.Put + '/' + this.state.requestId,
          this.onSubmitAfterUpdate,
        );
      });
    }
  };
  onSubmitAfterUpdate = (data) => {
    if (data.code === 1) {
      console.log(data.message);
      successMessage(data.message);

      Get(URLAPI.requestCategories.Get, this.getRequestCategory);

      //get the index of the edited record
      let index = this.state.catRecords.findIndex((x) => parseInt(x.id) === parseInt(data.id));

      //clone the record
      let _records = [...this.state.catRecords];

      //check if the record exist
      if (index >= 0) {
        //update the variables with the new ones
        _records[index].category = this.state.category;
      }

      //commit to state
      this.setState({ catRecords: _records, category: '', button: 'Save Record' });

      //this.handleCancel();
    } else if (data.code === 0) {
      console.log(data.message);

      errorMessage(data.message);
      this.setState({ loading: false, category: '', button: 'Save Record' });
    } else {
      errorMessage(data.message);
      this.setState({ loading: false, category: '', button: 'Save Record' });
    }
  };

  handleCancel = () => {
    this.setState({
      category: '',
      button: 'Save Record',
      bgColor: 'white',
    });
  };

  componentDidMount() {
    this._isMounted = true;
    try {
      Get(URLAPI.requestCategories.Get, this.getRequestCategory);
    } catch (err) {
      console.log(err);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { category, button, loading } = this.state;
    return (
      <>
        {loading ? (
          <LoadingSpinner />
        ) : (
          <div className='row'>
            <div className='col-4'>
              <div
                className='w-100  p-10 m-l-10 pd-b-0  h-10'
                style={{ background: this.state.bgColor }}>
                <form>
                  <TextInput
                    type='text'
                    value={category}
                    onChange={(e) => this.handleChange(e)}
                    label='Create Category'
                    name='category'
                    required
                    color='rgba(112,112,112,.7)'
                  />
                  {/* <TextInput
              type='text'
              value={sequence}
              onChange={(e) => this.handleChange(e)}
              label='Description'
              color='rgba(112,112,112,.7)'
            /> */}
                  {/* <div className='h-100'> */}
                  <div
                    className='w-100 m-b-auto flex flex-v-center space-between m-t-10'
                    style={{ alignSelf: 'flex-end' }}>
                    <button
                      className='btn btn-large w-49 p-10'
                      type='submit'
                      onClick={this.onSubmit}>
                      {button}
                    </button>
                    <button
                      className='btn-large w-49 cancel-btn p-10'
                      type='button'
                      onClick={this.handleCancel}>
                      Cancel
                    </button>
                  </div>
                  {/* </div> */}
                </form>
              </div>
            </div>

            <div className='col-8'>
              <div
                className='table-view '
                style={{
                  borderCollapse: 'collapse',
                  borderSpacing: '5px 15px',
                  // border: 'none',
                  ...this.props.overrideTableStyles,
                }}>
                <div
                  className='table-header'
                  style={{
                    backgroundColor: `${this.props.headerBGColor || '#43425D'}`,
                    color: `${this.props.headerColor || 'white'}`,
                  }}>
                  <div className='table-row'>
                    <div className='th case title w-25' style={{ ...bottomBorder }}>
                      <GiRecycle fontSize='20px' />
                    </div>
                    <div className='th case title w-25' style={{ ...bottomBorder }}>
                      <p>Category</p>
                    </div>
                    <div className='th case title w-25' style={{ ...bottomBorder }}>
                      <p>Last Updated</p>
                    </div>
                    <div className='th case title w-25' style={{ ...bottomBorder }}>
                      <p>Updated By</p>
                    </div>
                    <div className='th case title w-25' style={{ ...tableBorder }}>
                      <p>Action</p>
                    </div>
                  </div>
                </div>
                {this.state.catRecords.length !== 0 ? (
                  <h3>No category created</h3>
                ) : (
                  <div className='table-body no-border'>
                    {this.state.catRecords.map((item) => (
                      <div className='table-row no-border' key={item.id}>
                        <div className='td left-text font-sz-22 pointer' style={{ ...tableBorder }}>
                          <GrEdit onClick={() => this.onEdit(item)} />
                        </div>
                        <div
                          className='td font-sz-13'
                          style={{
                            ...tableBorder,
                          }}>
                          {''}
                        </div>
                        <div className='td font-sz-13' style={{ ...tableBorder }}>
                          {''}
                        </div>
                        <div className='td font-sz-13' style={{ ...tableBorder }}>
                          {Cookies.get('_FullName') || Cookies.get('fullname')}
                        </div>

                        <div className='td m-l-10 font-sz-22 pointer' style={{ ...tableBorder }}>
                          <GiTrashCan onClick={() => this.handleDeleteRecord(item)} />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>

        )}
      </>
    );
  }
}

export default DisposalCAtegoryForm;
